module.exports = __webpack_public_path__ + "zmenseni-prsou_2_after.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/img/llc/surgery/procedures/plasticka-chirurgie/zmenseni-prsou_2_after.jpg
// module id = 1279
// module chunks = 0